var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32951 1.3295C3.54048 1.11853 3.82663 1 4.125 1H14.25C14.5483 1.00006 14.8344 1.11863 15.0454 1.32962L20.6704 6.95463C20.8814 7.16555 20.9999 7.45166 21 7.75V20.125C21 21.0201 20.6444 21.8786 20.0115 22.5115C19.3786 23.1444 18.5201 23.5 17.625 23.5H6.375C5.47989 23.5 4.62145 23.1444 3.98851 22.5115C3.35558 21.8786 3 21.0201 3 20.125V2.125C3 1.82663 3.11853 1.54048 3.32951 1.3295ZM6.8821 18.0358C6.51469 17.5305 6.62646 16.823 7.13174 16.4556L14.1763 11.3333C14.6815 10.9659 15.389 11.0777 15.7564 11.583L16.4424 12.5265C16.8098 13.0318 16.6981 13.7392 16.1928 14.1066L9.14827 19.2289C8.64299 19.5963 7.93554 19.4845 7.56813 18.9792L6.8821 18.0358ZM14.6654 3.2624L18.6997 7.29665H14.6654V3.2624Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnoreicon);
export default __webpack_public_path__ + "static/media/ignore.icon.03602f2f4e926372993feefede672d55.svg";
export { ForwardRef as ReactComponent };